import Button from "../UI/Button";
import { useState } from "react";
import Callout from "../UI/Callout";
import { handleAPIError } from "../../utils/index.jsx";
import useLoader from "../../hooks/use-loader";

export default function GenerateAllQuittances({ onSubmit }) {
  const [error, setError] = useState("");
  const [isLoading, generateAllQuittances] = useLoader(onSubmit);
  async function generateAllQuittancesHandler() {
    try {
      setError("");
      await generateAllQuittances();
    } catch (e) {
      setError(handleAPIError(e));
    }
  }
  return (
    <>
      <p>
        Cette fonction permet de générer les quittances pour tous les
        locataires, jusqu'a la date à laquelle ils sont à jour de leur loyer.
      </p>
      <p>
        Les quittances ne seront pas envoyés par mail au locataire, mais seront
        mise à disposition dans son espace Qalimo.
      </p>
      <Callout variant="warning">
        En fonction du nombre de quittance à générer, cette opération peut
        prendre plusieurs minutes.
      </Callout>
      <div className={"text-center marginT10"}>
        <Button isLoading={isLoading} onClick={generateAllQuittancesHandler}>
          Générer les quittances de tous les locataires
        </Button>
      </div>
      <Callout variant="danger">{error}</Callout>
    </>
  );
}
